import { Modal } from "@mantine/core";
import { default as ReactMarkdown } from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import type { PluggableList } from "unified";
import type { ICMDocument } from "./MetadataDocuments/types";
import { MDA, MDCode, MDTable } from "./markdown/MarkdownComponents";

interface ICMDocumentModalProps {
    document: ICMDocument | null;
    onClose: () => void;
}

const ICMDocumentModal = ({ document, onClose }: ICMDocumentModalProps) => {
    const fullText = document?._source?.metadata?.full_text || "";
    const title = document?._source?.metadata?.display_title;
    ("ICM Document");

    return (
        <Modal
            opened={document !== null}
            onClose={onClose}
            title={title}
            size="xl"
            styles={{
                body: {
                    maxHeight: "70vh",
                    overflow: "auto",
                },
            }}
        >
            <div className="markdown" data-testid="markdown">
                <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    rehypePlugins={[rehypeRaw] as PluggableList}
                    components={{
                        table: MDTable,
                        code: MDCode,
                        a: MDA,
                    }}
                >
                    {fullText}
                </ReactMarkdown>
            </div>
        </Modal>
    );
};

export default ICMDocumentModal;
